import store from "@/store";
import { getToken } from "@/utils/auth";
export default [
    {
        path: "/account",
        redirect: "parentProfile",
        component: () => import("@/views/account"),
        children: [
            {
                name: "parentProfile",
                path: "/parentProfile",
                beforeEnter: (to, from, next) => {
                    if (getToken()) {
                        next();
                    } else {
                        store.dispatch("setToPath", "/parentProfile");
                        next({ path: "/login" });
                    }
                },
                component: () => import("@/views/account/parentProfile"),
                meta: {
                    roles: ["parent"],
                },
            },
            {
                name: "studentProfile",
                path: "/studentProfile",
                component: () => import("@/views/account/studentProfile"),
                meta: {
                    roles: ["parent"],
                },
            },
            {
                name: "studyRecordCount",
                path: "/studyRecordCount",
                component: () => import("@/views/account/studyRecordCount"),
                meta: {
                    roles: ["parent"],
                },
            },
            {
                name: "studyRecord",
                path: "/studyRecord",
                component: () => import("@/views/account/studyRecord"),
                meta: {
                    roles: ["parent"],
                },
            },
            {
                name: "purchaseHistory",
                path: "/purchaseHistory",
                component: () => import("@/views/account/purchaseHistory"),
                meta: {
                    roles: ["parent"],
                },
            },
            {
                name: "purchaseDetail",
                path: "/purchaseDetail/:id",
                props: (route) => ({ id: Number(route.params.id) }),
                component: () => import("@/views/account/purchaseDetail"),
                meta: {
                    roles: ["parent"],
                },
            },
        ],
    },
];
